<template>
  <div class="tags" v-if="tags && tags.length > 0 && $global.tab.title === 'auto_index' && page === 1">
    <div class="box-b about-tag">
      <div class="hd">
        <a href="//www.pcauto.com.cn/tag/sy/?ad=4420#a7" class="mark mark-link" target="_blank">相关文章标签</a>
      </div>
      <div class="bd">
        <ul class="txts txts-poin clearfix" id="j-tag-txts">
          <li v-for="(tag,index) in tags" :key="index">
            <a target="_blank" :href="tag.pub_url" @click="countAd(4537)">{{tag.word}}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Tags',
    props: {
        relateTagWord: {
            type: Array,
            default: () => ([])
        },
        propP: { //拿取当前页面
            type: Number,
            default: 1,
        }
    },
    data() {
        return {
            tags: [], //标签数据
             page: 1, //当前页
        }
    },
    watch: {
        relateTagWord(n) {
            this.tags = n
        },
        propP(n) {
            this.page = n
        }
    }
};
</script>

<style lang="scss" scoped>
.tags {
    margin-bottom: 25px;
    .box-b {
        .hd {
            height: 45px;
            line-height: 45px;
            border-bottom: 1px solid #eee;
            margin-bottom: 10px;
            .mark {
                font-size: 16px;
                font-family: 'Microsoft yahei';
                color: #259;                
            }
        }
        .bd {
            ul {
                display: flex;
                flex-wrap: wrap;
                li {
                    display: list-item;
                    border: 1px solid #eee;
                    border-radius: 10px;
                    padding: 2px 10px;
                    margin-bottom: 10px;
                    margin-right: 10px;
                    &:hover {
                        border: 1px solid #ff6600;
                    }
                    a {
                        color: #535353;
                        display: block;
                        font-size: 12px;
                    }
                }
            }
        }
    }
}
</style>
